export const decodeChangelog = (changelogContents: string): [Date, string[]][] => {
  const releases = changelogContents.split('---').map((v) => v.trim().split('\n'));

  const releasesByDate: Record<string, string[]> = {};

  releases.forEach((release) => {
    if (release.length !== 2) {
      return;
    }

    const desc = release[0];
    const listOfIds = release[1]?.split(' ');
    const date = desc?.split(' on ')[1].trim();

    if (!releasesByDate[date]) {
      releasesByDate[date] = listOfIds;
    } else {
      releasesByDate[date].push(...listOfIds);
    }
  });

  // convert this to array
  const releasesArray: [Date, string[]][] = [];
  Object.entries(releasesByDate).forEach(([date, ids]) => {
    const uniqueIDs = new Set(ids);
    const sortedIDs = Array.from(uniqueIDs);
    sortedIDs.sort((a, b) => a.localeCompare(b));
    releasesArray.push([new Date(date), sortedIDs]);
  });

  // sort by date, newest first
  releasesArray.sort((a, b) => b[0].getTime() - a[0].getTime());

  releasesArray.reverse(); // reverse to have oldest first, as we want to show the oldest first in the changelog
  // filter out duped PR IDs from multiple days, leaving the earliest appearance only
  const seenIDs = new Set<string>();
  releasesArray.forEach(([date, ids]) => {
    const filteredIDs = ids.filter((id) => {
      if (seenIDs.has(id)) {
        return false;
      }
      seenIDs.add(id);
      return true;
    });
    ids.length = 0; // clear the original array
    ids.push(...filteredIDs); // push the filtered IDs back into the original array
  });
  releasesArray.reverse(); // original order

  return releasesArray;
};
